import Icon from '../components/Icon.vue'

Icon.register({
  jedi: {
    width: 544,
    height: 512,
    paths: [
      {
        d: 'M480 352h40c-42.6 94.2-137.6 160-248 160-4.3 0-8.5-0.1-12.8-0.3-104-4.8-193.9-69.5-235.1-159.7h39.9l-58.6-58.6c-2.6-12.9-4.5-26-5.1-39.4-0.5-10.1-0.1-20.1 0.5-30h47.2l-41.4-41.4c14.4-64.7 52.1-122.5 108-162.1 2.8-2 6-3 9.3-3 5.4 0 10.4 2.7 13.5 7.3 3 4.5 3.6 10 1.6 15.1-6.5 16.5-9.8 33.7-9.8 51.3 0 45.1 21 86.6 57.7 113.7 4 3 6.5 7.5 6.7 12.4 0.2 4.9-1.8 9.7-5.5 13-26.5 24-41.2 56.5-41.2 91.6 0 60 43 110.3 99.9 121.9l2.5-65.3-27.2 18.5c-3 2-7.4 1.7-10-0.8-2.7-2.6-3.3-6.7-1.4-9.9l20.1-33.8-42.1-8.7c-3.7-0.8-6.4-4.1-6.4-7.8 0-3.8 2.7-7.1 6.4-7.8l42.1-8.7-20.1-33.7c-1.9-3.3-1.4-7.4 1.4-9.9 2.7-2.6 6.9-2.9 10-0.8l30.4 20.7 11.5-288c0.2-4.3 3.7-7.7 8-7.7h0c4.3 0 7.8 3.4 8 7.7l11.5 287.9 30.4-20.7c3-2.1 7.3-1.8 10 0.8 2.7 2.6 3.3 6.7 1.4 9.9l-20.1 33.8 42.1 8.7c3.7 0.8 6.4 4.1 6.4 7.8 0 3.8-2.7 7.1-6.4 7.8l-42.1 8.7 20.1 33.7c0.6 1.1 1.1 2.9 1.1 4.1 0 1.9-1.1 4.5-2.5 5.8-2.6 2.5-7 2.9-10 0.8l-27.2-18.5 2.5 65.3c48.5-9.4 87.6-48.2 97.3-96.5 8.8-43.6-5.6-87.3-38.6-117.1-3.7-3.4-5.7-8.1-5.5-13 0.2-4.9 2.7-9.4 6.7-12.4 36.7-27.2 57.7-68.6 57.7-113.7 0-17.6-3.3-34.8-9.9-51.3-2-5.1-1.4-10.6 1.6-15.1 3.1-4.5 8.1-7.2 13.5-7.2 3.3 0 6.5 1 9.3 3 55.5 39.2 93.4 97.5 107.9 162.3l-41.3 41.2h47c0.4 5.8 1 11.5 1 17.3 0 17.7-1.8 35.1-5.1 51.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/jedi.js
// module id = 1492
// module chunks = 0